const origin = window.location.origin;

// 通过域名格式来判定环境
const env = {
  isTest: /.qa|(\.qa)/.test(origin),
  isDev: /.dev|(\.dev)/.test(origin),
  isRelease: /.release|(\.release)/.test(origin)
};

//缓存用
const getCurrentEvn = () => {
  if (env.isTest) {
    return 'test';
  }
  if (env.isDev) {
    return 'dev';
  }
  if (env.isRelease) {
    return 'release';
  }
  return 'pro';
};
//域名跳转用
const getDomainEnvName = () => {
  if (env.isTest) {
    return '.qa';
  }
  if (env.isDev) {
    return '.dev';
  }
  if (env.isRelease) {
    return '.release';
  }
  return '';
};

//云译客域名
const getTranspaceDomain = () => {
  if (env.isTest) {
    return 'http://transpace.qa.iol8.net';
  }
  if (env.isDev) {
    return 'http://transpace.dev.iol8.net';
  }
  if (env.isRelease) {
    return 'http://transpace.release.iol8.net';
  }
  return 'https://transpace.iol8.com';
};

const getCatUrlDomain = () => {
  if (env.isTest) {
    // 目前sas只有两个环境
    return '//cat-dot.qa.iol8.net';
  }
  if (env.isDev) {
    return '//cat-dot.dev.iol8.net';
  }
  if (env.isRelease) {
    return '//cat-dot.release.iol8.net';
  }
  return '//cat-dot.iol8.com';
}; //webcat域名

// 获取cloud的baseUrl
export const getCloudBaseUrl = () => {
  if (env.isTest) {
    // const regex = /^[a-z]+-([a-z0-9]+)\./i;
    // const match = window.location.hostname.match(regex);
    // const environment = match ? match[1] : 'qa';
    // return `//cloud.${environment}.iol8.net`;
    return '//cloud.qa.iol8.net';
  }
  if (env.isDev) {
    return '//cloud.dev.iol8.net';
  }
  if (env.isRelease) {
    return '//cloud.release.iol8.net';
  }
  return '//cloud.iol8.com';
};
export const getSaasCloudBaseUrl = () => {
  if (env.isTest) {
    // const regex = /^[a-z]+-([a-z0-9]+)\./i;
    // const match = window.location.hostname.match(regex);
    // const environment = match ? match[1] : 'qa';
    // return `//cloud-saas.${environment}.iol8.net`;
    return '//cloud-saas.qa.iol8.net';
  }
  if (env.isDev) {
    return '//cloud-saas.dev.iol8.net';
  }
  if (env.isRelease) {
    return '//cloud-saas.release.iol8.net';
  }
  return '//cloud-saas.iol8.com';
};

// 获取sas的baseUrl
export const getSasBaseUrl = () => {
  if (env.isTest || env.isRelease) {
    // 目前sas只有两个环境
    return '//sas-server-dev.woordee.com';
  }
  if (env.isDev) {
    return '//sas-server-dev.woordee.com';
  }
  return '//sas-server.woordee.com';
};

// cloud域名接口包装
export const wrapCloud = (config: any) => {
  return {
    baseURL: getCloudBaseUrl(),
    ...config
  };
};

export const cloudBaseUrl = getCloudBaseUrl();
export const saasCloudBaseUrl = getSaasCloudBaseUrl();
export const sasBaseUrl = getSasBaseUrl();
export const catUrl = getCatUrlDomain();
export const currEvn = getCurrentEvn();
export const currDomainEnv = getDomainEnvName();
export const transpaceDomain = getTranspaceDomain();
